module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Informations de connexion équipe","text":"Scannez le QR code ou copiez le lien ci-dessous sur la tablette de l\u0027équipe pour la connecter","btnOk":"Ok"},"en":{"title":"Team Sign in information","text":"Scan the QR code or paste the link on the team\u0027s device","btnOk":"OK"}}')
  delete Component.options._Ctor
}
